import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { useAppContext } from "../_context";
import { useEffect, useState } from "react";

const TelephoneInput = ({
  id,
  containerStyle,
  inputStyle,
  buttonStyle,
  initialValue,
}) => {
  const [telephoneNumber, setTelephoneNumber] = useState("");
  const [{ locale }] = useAppContext();
  const defaultCountry = locale === "en" ? "gb" : "cz";

  useEffect(() => {
    if (initialValue) {
      setTelephoneNumber(initialValue);
    }
  }, [initialValue]);

  return (
    <>
      <PhoneInput
        containerStyle={{
          width: "100%",
          height: 47,
          ...containerStyle,
        }}
        inputStyle={{ height: "100%", ...inputStyle }}
        buttonStyle={buttonStyle}
        country={defaultCountry}
        value={telephoneNumber}
        onChange={(phone) => setTelephoneNumber(phone)}
        preferredCountries={["gb", "cz", "au"]}
        countryCodeEditable={false}
        inputProps={{ id: `phone-input-${id}` }}
      />
      <input type="hidden" id={id} value={`+${telephoneNumber}`} />
    </>
  );
};

export default TelephoneInput;
